import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import LoginModal from './loginModal';
import RegisterModal from './registerModal';
import CompanyRegisterModal from './companyRegisterModal';
import CompanyLoginModal from './companyLoginModal';
import logo from '../logo.png';
import './footer.css';

const SOCIALS = [
  { href: 'https://instagram.com', icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>, label: 'Instagram' },
  { href: 'https://facebook.com', icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>, label: 'Facebook' },
  { href: 'https://twitter.com', icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>, label: 'Twitter' },
];

export default function Footer() {
  const { t } = useTranslation();
  const [modals, setModals] = useState({
    login: false, register: false, companyLogin: false, companyRegister: false,
  });
  const [email, setEmail] = useState('');
  const [subscribeSuccess, setSubscribeSuccess] = useState(false);

  const open = (key) =>
    setModals({ login: false, register: false, companyLogin: false, companyRegister: false, [key]: true });
  const closeAll = () =>
    setModals({ login: false, register: false, companyLogin: false, companyRegister: false });

  const handleSubscribe = (e) => {
    e.preventDefault();
    setEmail('');
    setSubscribeSuccess(true);
    setTimeout(() => setSubscribeSuccess(false), 3000);
  };

  const handleAbout = (e) => {
    e.preventDefault();
    if (window.location.pathname !== '/') {
      window.location.href = '/#about-section';
    } else {
      document.getElementById('about-section')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContact = (e) => {
    e.preventDefault();
    if (window.location.pathname !== '/') {
      window.location.href = '/';
      setTimeout(() => window.dispatchEvent(new CustomEvent('showContactSection')), 400);
    } else {
      window.dispatchEvent(new CustomEvent('showContactSection'));
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="footer-root">
        {/* Wave top */}
        <svg className="footer-wave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 60" preserveAspectRatio="none">
          <path fill="var(--bg, #F0EDFF)" d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" />
        </svg>

        {/* Gradient line */}
        <div className="footer-gradient-line" />

        {/* Stats bar */}
        <div className="footer-stats">
          <Container>
            <div className="footer-stats-inner">
              {[
                { value: '1000+', label: t('footer.stats.events') },
                { value: '50+', label: t('footer.stats.cities') },
                { value: '100%', label: t('footer.stats.free') },
                { value: '🇮🇹', label: t('footer.stats.made') },
              ].map(s => (
                <div key={s.label} className="footer-stat">
                  <div className="footer-stat-value">{s.value}</div>
                  <div className="footer-stat-label">{s.label}</div>
                </div>
              ))}
            </div>
          </Container>
        </div>

        {/* Body */}
        <Container>
          <div className="footer-body">
            <Row>
              {/* Brand */}
              <Col lg={4} md={6} className="mb-4 mb-lg-0">
                <img src={logo} alt="EventHappy" height="36" style={{ marginBottom: '1rem', display: 'block' }} />
                <p className="footer-brand-desc">{t('footer.tagline')}</p>
                <div className="footer-socials">
                  {SOCIALS.map(s => (
                    <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer"
                      aria-label={s.label} className="footer-social-btn">
                      {s.icon}
                    </a>
                  ))}
                </div>
              </Col>

              {/* Esplora */}
              <Col lg={2} md={3} sm={6} className="mb-4 mb-lg-0">
                <p className="footer-col-heading">{t('footer.explore')}</p>
                <Link to="/" className="footer-link">Home</Link>
                <button onClick={handleAbout} className="footer-link">{t('nav.about')}</button>
                <button onClick={handleContact} className="footer-link">{t('nav.contact')}</button>
                <button onClick={(e) => { e.preventDefault(); open('companyLogin'); }} className="footer-link">
                  ⚡ {t('nav.companies')}
                </button>
              </Col>

              {/* Legale */}
              <Col lg={2} md={3} sm={6} className="mb-4 mb-lg-0">
                <p className="footer-col-heading">{t('footer.legal')}</p>
                <Link to="/privacy-policy" className="footer-link">{t('footer.privacy')}</Link>
                <Link to="/terms-of-service" className="footer-link">{t('footer.terms')}</Link>
              </Col>

              {/* Newsletter + accesso */}
              <Col lg={4} md={12}>
                <p className="footer-col-heading">{t('footer.newsletter_title')}</p>
                <p className="footer-newsletter-desc">{t('footer.newsletter_desc')}</p>
                {subscribeSuccess && (
                  <div className="footer-subscribe-success">{t('footer.newsletter_success')}</div>
                )}
                <form onSubmit={handleSubscribe} className="footer-newsletter-form">
                  <input
                    type="email"
                    placeholder={t('footer.newsletter_placeholder')}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    className="footer-newsletter-input"
                  />
                  <button type="submit" className="footer-newsletter-btn">{t('footer.newsletter_btn')}</button>
                </form>

                <div className="footer-access-btns">
                  <button onClick={() => open('login')} className="footer-access-btn footer-access-btn-ghost">
                    {t('nav.login')}
                  </button>
                  <button onClick={() => open('register')} className="footer-access-btn footer-access-btn-grad">
                    {t('nav.register')}
                  </button>
                  <button onClick={() => open('companyLogin')} className="footer-access-btn footer-access-btn-purple">
                    ⚡ {t('nav.companies')}
                  </button>
                </div>
              </Col>
            </Row>

            {/* App coming soon */}
            <div style={{ textAlign: 'center', padding: '0.75rem 0', borderTop: '1px solid rgba(124,58,237,0.12)', marginBottom: '0.5rem' }}>
              <span style={{ fontSize: '0.78rem', color: 'rgba(120,100,200,0.7)', letterSpacing: '0.01em' }}>
                {t('footer.app_coming')}
              </span>
            </div>

            {/* Bottom bar */}
            <div className="footer-bottom">
              <span className="footer-copyright">
                © {currentYear} EventHappy — Made with ❤️ by Aaron Ferrari
              </span>
              <div className="footer-bottom-right">
                <span className="footer-version">v1.2.0</span>
                <a href="#top" className="footer-top-link">{t('footer.back_top')}</a>
              </div>
            </div>
          </div>
        </Container>
      </footer>

      <LoginModal show={modals.login} onHide={closeAll}
        onSwitchToRegister={() => open('register')}
        onSwitchToCompanyRegister={() => open('companyRegister')}
        onLoginSuccess={closeAll} />

      <RegisterModal show={modals.register} onHide={closeAll}
        onSwitchToLogin={() => open('login')}
        onSwitchToCompanyRegister={() => open('companyRegister')} />

      <CompanyRegisterModal show={modals.companyRegister} onHide={closeAll}
        onSwitchToLogin={() => open('companyLogin')} />

      <CompanyLoginModal show={modals.companyLogin} onHide={closeAll}
        onSwitchToRegister={() => open('companyRegister')}
        onSwitchToLogin={() => open('login')}
        onLoginSuccess={closeAll} />
    </>
  );
}
